/**
 * Canonical config-area identifiers — one per configuration governance unit. A unit
 * may cover several settings tabs (`it` = Integrations/Security/User Properties;
 * `organisation_settings` = the remaining settings).
 */
export const CONFIG_AREAS = [
  'workflows_and_forms',
  'dynamic_assignees',
  'users_and_groups',
  'core_data',
  'document_review',
  'it',
  'organisation_settings',
] as const

/** A canonical config-area identifier. */
export type ConfigArea = (typeof CONFIG_AREAS)[number]
